<template>
    <el-row class="main-box  flex-column flex1">
        <el-col>
            <el-row>
                <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 24, offset: 0 }">
                    <div class="content-box flex-column">
                        <el-image class="content-box-bg" src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image3.jpg"
                            fit="cover" :lazy="true"></el-image>
                        <div class="content-box-title1">英语水平测试报告</div>
                        <div class="content-box-title2">成功是一步一步努力和积累的结果</div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 22, offset: 1 }"
                    :lg="{ span: 22, offset: 1 }">
					<div class="contetnt-info flex-column">
                    <div class="flex-row">
                        <div class="contetnt-info-left flex-cloumn ">
                            <div class="contetnt-info-left-title">
                                <div style="margin-top:4px;margin-bottom:8px;">
                                    {{ reportInfo.userName!=null&&reportInfo.userName!=''? reportInfo.userName : '体验用户' }}，你好 </div>
                                <div>{{opentype=='1'?'本课程测试正确率':'你的英语词汇量为'}}</div>
                            </div>
                            <div class="content-info-left-numbox flex-column f-center">
                                <el-image class="content-info-left-numbox-bg"
                                    :src="require('@/static/vocabulary-text-report-numer-bg.png')" fit="scale-down"
                                    :lazy="true"></el-image>
                                <span class="content-info-left-numbox-text">{{reportInfo.vocabularyCount}}<span style="font-size: 50px;">{{opentype=='1'?'%':''}}</span>
									
								</span>
                            </div>
                            <div class="contetnt-info-left-name flex-row f-justify-center">
                                {{ reportInfo.userName!=null&&reportInfo.userName!=''? reportInfo.userName : '体验用户' }}</div>
                            <div class="contetnt-info-left-info flex-row f-center">
                                <span class="contetnt-info-left-info-text1">性别：</span>
                                <span class="contetnt-info-left-info-text2" style="margin-right:54px;">{{reportInfo.userSex!=null?getSexStr(reportInfo.userSex) : '—' }}</span>
                                <span class="contetnt-info-left-info-text1">年龄：</span>
                                <span class="contetnt-info-left-info-text2">{{ reportInfo.birthday!=null&&reportInfo.birthday!='' ?
                                    getAgeStr(reportInfo.birthday) : '—' }}</span>
                            </div>
                            <div class="flex-row f-center">
                                <div class="contetnt-info-left-bnts flex-cloumn f-center">
                                    相当于{{ reportInfo.gradeName }}
                                </div>
                            </div>
                        </div>

                        <!-- <el-image class="contetnt-info-right-img" :src="require('@/static/report-reference-img.png')" fit="scale-down" :lazy="true"></el-image> -->
                     <div v-if="opentype=='1'" class="level-box flex-row">
                         <div class="flex-row flex1">
                             <div class="level-box-left1 flex-column">
                                 <span v-for="(item, index) in LevelInfoList1" :key="'levelname_' + index">{{
                                     item.labelName }}</span>
								<span style="font-family: Source Han Sans;font-size: 20px;font-weight: bold;color: #333333;">各学段英语词汇量水平等级划分</span>
                             </div>
                             <div class="level-box-right1 flex-column">
                                 <div v-for="(item, index) in LevelInfoList1" :key="'levelnum_' + index">
                                     <span>正确率</span>
                                     <span>{{ item.labelvule}}</span>
                                 </div>
                             </div>
                         </div>
                     </div>
					
					 <div  v-else class="level-box flex-row f-center">
						<el-image 
						style="width: 695.38px;
								height: 489.41px;"
						 :src="require('@/static/vocabulary_test_bg1.png')" 
						    fit="cover" :lazy="true"></el-image>
					 </div> 
					<!-- 	 <div  v-else class="level-box flex-row">
                            <div class="flex-row flex1">
                                <div class="level-box-left flex-column">
                                    <span v-for="(item, index) in LevelInfoList" :key="'levelname_' + index">{{
                                        item.labelName }}</span>
										  </div>
                                <div class="level-box-right flex-column">
                                    <div v-for="(item, index) in LevelInfoList" :key="'levelnum_' + index">
                                        <span>词汇量</span>
                                        <span>{{ item.startValue }}—{{ item.endValue }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
						
						
						
						
                    </div>
					<div  class="flex-row f-justify-end">
						<div  @click="showdatapup()" class="faclss"  style="color: white;background-color: #58BC98;">
							查看分析
						</div>
						<div v-if="userInfos.role == 1"  @click="black()" style="margin-left: 20px;" class="faclss">
							返回
						</div>
					</div>
					</div>
                </el-col>
					
            </el-row>


        </el-col>
		
		
		
		<el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">
		    <el-row slot="title" style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="appraise-popup-title flex-row f-justify-between f-align-center">
		                <div style="width:56px;height:56px;"></div>
		                <span class="appraise-popup-title-name">查看分析</span>
		                <img @click="dialogConfrimStartClass = false" src="../static/close.png" alt="">
		            </div>
		
		        </el-col>
		    </el-row>
		    <el-row style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="start-popup-content flex-column f-align-center">
						<div class="chk_lcs flex-cloumn">
							<div class="flex-row f-center">
								<img src="../static/voca_bg_ler1.png" style="width: 27px;height: 11px;" alt="">
								<span class="chk_lcstext" >语言能力</span>
								<img src="../static/voca_bg_ler2.png" style="width: 27px;height: 11px;"  alt="">
							</div>
							<span style="28px">{{reportInfo.languageCapacity}}</span>
						</div>
		             
					 
					 <div class="chk_lcs flex-cloumn">
					 	<div class="flex-row f-center">
					 		<img src="../static/voca_bg_ler1.png" style="width: 27px;height: 11px;" alt="">
					 		<span class="chk_lcstext" >测评分析</span>
					 		<img src="../static/voca_bg_ler2.png" style="width: 27px;height: 11px;"  alt="">
					 	</div>
					 	<span style="28px">{{reportInfo.evaluationAnalysis}}</span>
					 </div>
					 
					 <div class="chk_lcs flex-cloumn">
					 	<div class="flex-row f-center">
					 		<img src="../static/voca_bg_ler1.png" style="width: 27px;height: 11px;" alt="">
					 		<span class="chk_lcstext" >学习建议</span>
					 		<img src="../static/voca_bg_ler2.png" style="width: 27px;height: 11px;"  alt="">
					 	</div>
					 	<span style="28px">{{reportInfo.learningAdvice}}</span>
					 </div>
		            </div>
		
		        </el-col>
		    </el-row>
		</el-dialog>
		
    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Message } from 'element-ui';
import moment from "moment";
import ToolsUtils from '../common/toolsUtils';

export default {
    data() {
        return {
            frontUserId: "",
            reportInfo: {},
            LevelInfoList: [],
			    dialogConfrimStartClass: false,
			LevelInfoList1: [
				{
					labelName:'非常熟练',
					labelvule:'80%-100%' 
				},
				{
					labelName:'熟练',
					labelvule:'60%-80%' 
				},
				{
					labelName:'高级',
					labelvule:'40%-60%' 
				},
				{
					labelName:'中级',
					labelvule:'20%-40%' 
				},
				{
					labelName:'初级',
					labelvule:'0%-20%' 
				}
			],
			opentype:"0",//首頁進來0  其它上課是1
        }
    },
    computed: {
        ...mapState([
            'userInfos',
        ]),
        ...mapGetters(["getUserToken"])
    },
    created() {
        let queryParams = this.$route.query;
        if (!ToolsUtils.isObjEmpty(queryParams)) {
            this.frontUserId = queryParams.frontUserId;
			this.opentype = queryParams.opentype;
        }

        this.getReportInfo();
		if(this.opentype!="1")
        this.getLevelInfo()
    },
    methods: {
		showdatapup(){
			   this.dialogConfrimStartClass = true;
		},getSexStr(type) {
            if (type == 0) {
                return '男'
            } else if (type == 1) {
                return '女'
            } else {
                return '未知'
            }
        },
        getAgeStr(brith) {
            let currentDate = moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD");
            let brithDate = moment(brith, "YYYY-MM-DD").format("YYYY-MM-DD")
            return moment(currentDate).diff(brithDate, "years");
        },
        async getReportInfo() {
            if (this.userInfos.role == 0) {

                let queryParams = this.$route.query;
                if (!ToolsUtils.isObjEmpty(queryParams)) {

                    this.$nextTick(() => {
                        this.reportInfo = queryParams.detail ? JSON.parse(decodeURIComponent(queryParams.detail)) : {}
                        console.log(this.reportInfo)
                    })
                }

            } else if (this.userInfos.role == 1) {

                if (ToolsUtils.isStrEmpty(this.frontUserId)) {
                    let queryParams = this.$route.query;
                    if (!ToolsUtils.isObjEmpty(queryParams)) {

                        this.$nextTick(() => {
                            this.reportInfo = queryParams.detail ? JSON.parse(decodeURIComponent(queryParams.detail)) : {}
                            console.log(this.reportInfo)
                        })
                    }
                }

            }
			this.showdatapup();
        },
        async getLevelInfo() {
            let res = null;
            let apiUrl = "";
            if (this.userInfos.role == 0) {
                apiUrl = "web/frontUser/student/vocabularyTestLevelList"
            } else if (this.userInfos.role == 1) {
                apiUrl = "web/frontUser/teacher/vocabularyTestLevelList"
            }

            res = await this.$api.get(apiUrl, {
                headers: { //头部参数
                    frontUserToken: this.getUserToken
                },
            });
            if (res.code == 200) {
                this.LevelInfoList = res.data ? res.data.levelScopeVos.reverse() : []
            } else {
                Message({
                    type: "error",
                    message: res.msg
                })
            }
        },
		black(){
			 this.$router.back();
		}

    }
}
</script>

<style lang="scss" scoped>
.main-box {
    background: #E5F3F1;

    position: relative;
	
	
	.chk_lcs{
		width: 100%;
		border-radius: 20px;
		margin-top: 24px;
		background: #E5F7F1;
		box-sizing: border-box;
		border: 1px solid rgba(10, 162, 107, 0.2);
		padding-top: 15px;
		padding-bottom: 15px;
		padding-left: 30px;
		padding-right: 30px;
		font-family: Source Han Sans;
		font-size: 16px;
		font-weight: normal;
		line-height: 30px;
		letter-spacing: 0em;
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		color: #3D3D3D;
	}
	
	
	.chk_lcstext{
		font-family: Source Han Sans;
		font-size: 20px;
		margin-left: 8px;
		margin-right: 8px;
		font-weight: bold;
		line-height: 30px;
		display: flex;
		align-items: center;
		letter-spacing: 0em;
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		color: #3D3D3D;
	}
	

    .content-box-col {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
	.faclss{
		margin-top: 60px;
		width: 230px;
		height: 64px;
		border-radius: 100px;
		opacity: 1;
		/* 灰 */
		background: #ACBEB0;
		font-family: 思源黑体;
		font-size: 28px;
		font-weight: bold;
		line-height: 64px;
		text-align: center;
		letter-spacing: 0em;
		
		font-feature-settings: "kern" on;
		/* 纯白 */
		color: #FFFFFF;
		
	}

    .content-box {
        width: 100%;
        height: 230px;
        position: relative;

        .content-box-bg {
            width: 100%;
            height: 309px;
            position: absolute;
            top: -42px;
            left: 0;
        }

        .content-box-title1 {
            margin-top: 50px;
            margin-left: 212px;
            font-family: HelloFont WenYiHei;
            font-size: 50px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;
            color: #FFFFFF;
            position: relative;
            z-index: 20;
        }

        .content-box-title2 {
            font-family: 思源黑体;
            font-size: 20px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            color: #FFFFFF;
            margin-top: 3px;
            margin-left: 212px;
            position: relative;
            z-index: 20;
        }

    }

    .contetnt-info {
        padding: 30px 30px 27px 30px;
        width: 91.4777%;
     
        border-radius: 20px;
        box-sizing: border-box;

        background: #FFFFFF;
        transform: translateY(-30px);

        .contetnt-info-left {
            width: 22.743%;
            margin-right: 39px;

            .contetnt-info-left-title {
                margin-left: 35px;

                span {
                    font-family: Source Han Sans CN;
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 30px;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 333333 */
                    color: #333333;
                }
            }

            .content-info-left-numbox {
                margin-top: 20px;
                width: 100%;
                height: 352px;
                position: relative;

                .content-info-left-numbox-bg {
                    width: 100%;
                    height: 352px;
                }

                .content-info-left-numbox-text {
                    position: absolute;
                    font-family: Oswald;
                    font-size: 90px;
                    font-weight: normal;
                    line-height: normal;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 绿 */
                    color: #0AA26B;
                }
            }

            .contetnt-info-left-name {
                margin-top: 11px;
                font-family: Source Han Sans CN;
                font-size: 30px;
                font-weight: normal;
                line-height: 30px;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

            .contetnt-info-left-info {
                margin-top: 13px;

                .contetnt-info-left-info-text1 {

                    font-family: Source Han Sans CN;
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 30px;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 灰 */
                    color: #ACBEB0;
                }

                .contetnt-info-left-info-text2 {
                    font-family: Source Han Sans CN;
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 30px;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 333333 */
                    color: #333333;
                }


            }

            .contetnt-info-left-bnts {
                text-align: center;
                margin-top: 22px;
                width: 234px;
                line-height: 42px;
                height: 42px;
                border-radius: 20px;
                opacity: 1;

                background: linear-gradient(289deg, #F8FFFC -20%, #D9F1E5 103%);

                box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);

                font-family: 思源黑体;
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 绿 */
                color: #0AA26B;
            }

        }

        .contetnt-info-right-img {
            width: 75.049%;
            height: 574px;
        }


    }

    .level-box {
        padding: 30px 0 23px 76px;
        width: 96.666%;
        height: 574px;
        border-radius: 20px;
        opacity: 1;

        background: #E5F7F1;

        box-sizing: border-box;
        border: 1px solid rgba(10, 162, 107, 0.2);

        .level-box-left {
            width: 48.489%;
            height: 473px;
            background: url(../static/report-reference--level-img.png) no-repeat;
            background-size: 100% 100%;
            text-align: center;

            span {
                display: inline-block;
                margin-top: 34px;
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: bold;
                line-height: 30px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;

                &:nth-child(4) {
                    margin-top: 38px;
                }

                &:nth-child(5) {
                    margin-top: 37px;
                }

                &:last-child {
                    margin-top: 40px;
                }
            }
        }
		.level-box-left1 {
            width: 48.489%;
            height: 454px;
            background: url(../static/report-reference--level-img1.png) no-repeat;
            background-size: 100% 100%;
            text-align: center;
 
            span {
                display: inline-block;
                margin-top: 55px;
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: bold;
                line-height: 40px;
                text-align: center; 
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;

                &:nth-child(4) {
                    margin-top: 38px;
                }

                &:nth-child(5) {
                    margin-top: 37px;
                }

                &:last-child {
                    margin-top: 40px;
                }
            }
        }
        .level-box-right {
            margin-top: 4px;
            width: 48.017%;

            div {
                text-align: end;
                padding-right: 29px;
                margin-top: 10px;
                background: url(../static/report-reference--level-numbg.png) no-repeat;
                background-size: 100% 100%;
                height: 57px;
                line-height: 57px;

                span {
                    &:first-child {
                        margin-right: 24px;
                        font-family: 思源黑体;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 333333 */
                        color: #333333;
                    }

                    &:last-child {

                        font-family: Oswald;
                        font-size: 20px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }


                }
            }
        }
		.level-box-right1 {
            margin-top: 4px;
            width: 48.017%;

            div {
                text-align: end;
                padding-right: 29px;
                margin-top: 30px;
                background: url(../static/report-reference--level-numbg.png) no-repeat;
                background-size: 100% 100%;
                height: 57px;
                line-height: 57px;

                span {
                    &:first-child {
                        margin-right: 24px;
                        font-family: 思源黑体;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 333333 */
                        color: #333333;
                    }

                    &:last-child {

                        font-family: Oswald;
                        font-size: 20px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }


                }
            }
        }
    }
	
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
		padding-bottom: 50px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 确认开始学员 */
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 100%;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	


    .appraise-popup-title {
        width: 100%;
        height: 86px;
        border-radius: 20px 20px 0 0;
        background: #0AA26B;
        box-sizing: border-box;
        padding: 0 35px;

        .appraise-popup-title-name {
            font-family: 思源黑体;
            font-size: 26px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

        img {
            width: 56px;
            height: 56px;
        }
    }
}


/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }

}
</style>